import React from 'react';
import * as properties from '../../elementsPropertiesItems';
import { v4 as uuidv4 } from 'uuid';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const GridSystem = (props)=>{
    const {changeHandler,path,keyParam,elementData} = props;
    // console.log('props',props);
    const onChangeHandler = (cols)=>{
        let addOrUpdateData = [];
        cols.map((col,colIndex)=>{
            //add new columns
            let arrayObj  ={
                id:uuidv4(),
                children:[],
                type:'Column',
                name:'div',
                attributes:{
                    style:{
                        width:col,
                        padding:'10px 10px 10px 10px'
                    }
                },
                properties:[                
                    {
                        type:'Padding',
                        label:'Padding',
                        keyParam:'padding',
                        path:'.attributes.style',
                    },
                    {
                        type:'BackgroundColor',
                        label:'Background Color',
                        keyParam:'backgroundColor',
                        path:'.attributes.style',
                    }
                ],
            };
            try{
                if(isSet(elementData.children,[])[colIndex]){
                    elementData.children[colIndex].attributes.style.width = col;
                    //replace with orginal column
                    arrayObj = elementData.children[colIndex];
                }
            }catch(e){

            }
            
            // isSet(elementData.children,[]).findIndex(())
            addOrUpdateData = [
                ...addOrUpdateData,
                arrayObj
            ]
        });
        changeHandler(path,keyParam,addOrUpdateData);
    }
    return(
        <>
        {properties.GridSystem.map((item,itemIndex)=>{
            const {value} = item;
           return(
            <div style={{border: '1px solid rgb(229, 229, 229)',width:'100%',padding:'10px'}} key={itemIndex} onClick={()=>onChangeHandler(value)}>
                <div style={{height: '16px',border:'1px solid rgb(85, 85, 85)',borderRadius:'3px',display:'flex'}}>
                    {value.map((val,valIndex)=>{
                        let cssObj = {};
                        if((valIndex+1)<value.length){
                            cssObj = {
                                borderRight:'1px solid rgb(85, 85, 85)'
                            }
                        }
                        
                        return(
                            <> 
                                <div style={{height:'100%',width:val,...cssObj}}></div>
                            </>
                        )
                    })}
                   
                </div>
            </div>
           )
        })}
            
        </>
    )
}

export default GridSystem;